import {
  Button,
  Card,
  Text,
  VSpacer,
} from '@/components/DesignSystem';
import { useQuery } from 'react-query';
import { QueryKeys } from '@/constants/QueryKeys';
import { RetailerApi } from '@/utilities/api/RetailerApi';
import { ApiRewardsProgram } from '@api/interfaces/ApiRewardsProgram';
import { ChurnTableHeader, ChurnTableData } from '@/components/shared/CustomerChurnStatusTable';
import {
  Box,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@/constants/Routes';

interface CustomerChurnSectionProps {
  program: ApiRewardsProgram,
  retailerId: string;
}

export const CustomerChurnSection = ({
  program,
  retailerId,
}: CustomerChurnSectionProps) => {

  const navigate = useNavigate();

  const { data: customers, isFetching } = useQuery(
    [QueryKeys.LIST_PRIMARY_CUSTOMERS, retailerId],
    async () => {
      const res = await RetailerApi.listTierCustomers(
        retailerId,
        {
          limit: 10,
          sort: "churnStatus",
          sortDesc: true,
          withPointsData: true,
        },
      );
      return res.data;
    },
  );

  const renderTableData = () => {
    if (isFetching) {
      return (
        <TableBody>
          <TableRow>
            <TableCell align="center" colSpan={12}>
              <CircularProgress />
            </TableCell>
          </TableRow>
        </TableBody>
      );
    }
    return <ChurnTableData customers={customers} program={program} />;
  };

  return (
    <Card
      cardContentStyle={{ height: '100%', padding: 0, width: '100%' }}
      sx={{ padding: '20px 20px 8px' }}
      testID="churn-table-card"
    >
      <Text fontSize="18px" fontWeight={400} >
        Top 10 customers by churn risk
      </Text>
      <VSpacer size="4" />
      <Box sx={{ overflowX: 'auto' }}>
        <Table sx={{ tableLayout: 'fixed' }}>
          <ChurnTableHeader />
          {renderTableData()}
        </Table>
      </Box>
      <VSpacer size="8" />
      <Stack direction="row" justifyContent="end" width="100%">
        <Button
          endIcon={<ArrowForward />}
          onClick={() => navigate(Routes.RETAILER_INSIGHTS)}
          testID="button-demo-enabled-outline-left-accessory"
          variant="outlined"
        >
          Get more Insights
        </Button>
      </Stack>
    </Card>
  );
};
